"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningsTooltip = void 0;
const queries_1 = require("@app/queries");
const util_1 = require("@app/util");
const apollo_1 = require("@app/util/apollo");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const WarningsTooltip = ({ laborlawPluginEnabled = false, laborlawPlugin = null, warningCountsFiltered = 0, hiddenWarnings = null, onChangeEnabledAll, onHandlePluginChange, shiftWarningTypes = [], countWarningsByType, setCalendarWarnings = () => { }, workspaceId, calendarDate, }) => {
    const shiftWarningTypesSorted = [...shiftWarningTypes];
    shiftWarningTypesSorted.sort((a, b) => {
        return a.level > b.level ? -1 : 1;
    });
    let alreadyDisplayingNotices = false;
    const toggleValue = Boolean(laborlawPluginEnabled &&
        (!hiddenWarnings ||
            (hiddenWarnings.hideWarnings !== 'all' &&
                hiddenWarnings.hideWarnings !== true))); // vaue is True if hideWarnings filter is not active and laborlaw plugin is enabled
    const { mutation: recalculateWarnings } = (0, apollo_1.useMutate)(queries_1.RecalculateWarnings, {
        variables: {
            workspace: workspaceId,
            from: calendarDate
                ? (0, moment_1.default)(calendarDate).format('YYYY-MM-DD')
                : (0, moment_1.default)().format('YYYY-MM-DD'),
        },
    });
    const lastRecalculate = () => {
        return window.localStorage.getItem('ds-warnings-last-recalculate')
            ? JSON.parse(window.localStorage.getItem('ds-warnings-last-recalculate') ?? '')
            : {};
    };
    const isAdmin = !!document.querySelector('.ds-adminpanel');
    const recalculateCooldownHours = isAdmin ? 0.001 : 1;
    const getCurrentDisabledVal = () => {
        return workspaceId && Object.keys(lastRecalculate()).includes(workspaceId)
            ? lastRecalculate()[workspaceId] &&
                (0, moment_1.default)(lastRecalculate()[workspaceId]).isValid()
                ? (0, moment_1.default)(lastRecalculate()[workspaceId])
                    .clone()
                    .add(recalculateCooldownHours, 'hours')
                    .isAfter((0, moment_1.default)())
                : false
            : false;
    };
    const [recalculateDisabled, setRecalculateDisabled] = (0, react_1.useState)(getCurrentDisabledVal());
    const recalculatingNow = () => {
        return Object.keys(lastRecalculate()).includes(workspaceId) &&
            (0, moment_1.default)(lastRecalculate()[workspaceId]).isValid()
            ? (0, moment_1.default)(lastRecalculate()[workspaceId])
                .add(isAdmin ? 1 : 120, 'seconds')
                .isAfter((0, moment_1.default)())
            : false;
    };
    const [recalculateTick, setRecalculateTick] = (0, react_1.useState)(-1);
    (0, react_1.useEffect)(() => {
        if (recalculatingNow()) {
            const interval = setInterval(() => {
                // this will trigger a re-render every second, while we're recalculating
                setRecalculateTick(recalculateTick + 1);
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [recalculateTick]);
    return (react_1.default.createElement(_ui_1.Tooltip, { position: _ui_1.Tooltip.POSITIONS.BOTTOM, clickable: true, className: 'ds-c-button-warnings-tooltip', width: '44ex', anchor: react_1.default.createElement(_ui_1.Button, { bold: true, ico: _ui_1.Icon.ICONS.warning, label: null },
            react_1.default.createElement(react_1.default.Fragment, null,
                (0, i18n_1.t)('WARNINGS'),
                laborlawPluginEnabled ? (warningCountsFiltered ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_6 }),
                    react_1.default.createElement(_ui_1.CircledNumber, { number: warningCountsFiltered, color: _ui_1.CircledNumber.COLORS.DANGER }))) : null) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_6 }),
                    react_1.default.createElement(_ui_1.CircledNumber, { number: '?' }))))) },
        react_1.default.createElement("div", { className: 'ds-warnings-plugin-title' },
            react_1.default.createElement(_ui_1.Text, { color: _ui_1.Text.COLORS.PRIMARY, weight: _ui_1.Text.WEIGHTS.BOLD }, (0, i18n_1.t)('WARNINGS')),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_16 },
                react_1.default.createElement(_ui_1.Toggle, { value: toggleValue, disabled: !laborlawPluginEnabled, onDisabledClick: () => {
                        util_1.notification.error({
                            code: '',
                            message: 'WARNINGS_ENABLE_DISABLE_TT_PLUGIN_WARN',
                        });
                    }, onClick: (e) => {
                        e.stopPropagation();
                    }, onChange: onChangeEnabledAll }))),
        toggleValue ? (react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_16 },
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_12 }),
            react_1.default.createElement(_ui_1.Button, { key: recalculateTick, disabled: recalculateDisabled, onClickActiveWhenDisabled: true, style: _ui_1.Button.STYLES.UNDERLINED, size: _ui_1.Button.SIZES.SMALL, label: recalculatingNow()
                    ? (0, i18n_1.t)('RECALCULATING') +
                        moment_1.default
                            .utc((0, moment_1.default)(lastRecalculate()[workspaceId])
                            .add(2, 'minutes')
                            .diff((0, moment_1.default)()))
                            .format(' (m:ss)')
                    : recalculateDisabled
                        ? (0, i18n_1.t)('RECALCULATE') +
                            ' (' +
                            (0, i18n_1.t)('AFTER') +
                            ' ' +
                            (0, moment_1.default)(lastRecalculate()[workspaceId])
                                .clone()
                                .add(recalculateCooldownHours, 'hours')
                                .format('HH:mm') +
                            ')'
                        : (0, i18n_1.t)('RECALCULATE'), onClick: () => {
                    if (!recalculateDisabled || !getCurrentDisabledVal()) {
                        recalculateWarnings()
                            .then(() => {
                            const newLastRecalculate = lastRecalculate();
                            newLastRecalculate[workspaceId] = (0, moment_1.default)().format();
                            window.localStorage.setItem('ds-warnings-last-recalculate', JSON.stringify(newLastRecalculate));
                            setRecalculateDisabled(true);
                            setRecalculateTick(1);
                        })
                            .catch(() => { });
                    }
                    else {
                        util_1.notification.error({
                            code: '',
                            message: (0, i18n_1.t)('WARNINGS_RECALCULATE_DISABLED_UNTIL', {
                                x: (0, moment_1.default)(lastRecalculate()[workspaceId])
                                    .clone()
                                    .add(recalculateCooldownHours, 'hours')
                                    .format('HH:mm'),
                            }),
                        });
                    }
                }, loading: recalculatingNow(), ico: _ui_1.Icon.ICONS.cycle }))) : null,
        !laborlawPluginEnabled && (react_1.default.createElement("div", { className: 'ds-warnings-plugin-enable-disable' },
            react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.POSITION.CENTER, align: _ui_1.Flex.POSITION.CENTER },
                react_1.default.createElement(_ui_1.Button, { style: _ui_1.Button.STYLES.CONTAINED, onClick: () => onHandlePluginChange?.(), label: (0, i18n_1.t)('WS_SETTINGS_CARD_PLUGINS_SETTINGS_PLUGIN_LABORLAW_ACTIVATE') })))),
        react_1.default.createElement("table", { className: 'ds-warnings-details-by-type' +
                (!laborlawPluginEnabled ? ' is-plugin-disabled' : ''), onClick: (e) => {
                e.stopPropagation();
            } },
            react_1.default.createElement("tbody", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null),
                    react_1.default.createElement("td", { className: 'is-desc-td', style: { overflow: 'visible' } },
                        react_1.default.createElement("div", { style: { marginLeft: '-1rem' } },
                            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD }, (0, i18n_1.t)('WARNING_TYPES_VIOLATIONS')))),
                    react_1.default.createElement("td", null)),
                laborlawPlugin &&
                    shiftWarningTypesSorted.map((w, wIdx) => {
                        const disabled = !laborlawPluginEnabled ||
                            (hiddenWarnings &&
                                (hiddenWarnings.hideWarnings === 'all' ||
                                    hiddenWarnings.hideWarnings === true ||
                                    (Array.isArray(hiddenWarnings.hideWarnings) &&
                                        hiddenWarnings.hideWarnings.includes(w.name))));
                        const handleChange = (val) => {
                            if (!laborlawPluginEnabled)
                                return false;
                            let enabledList = shiftWarningTypesSorted
                                .filter((w2) => !hiddenWarnings?.hideWarnings ||
                                (hiddenWarnings.hideWarnings !== 'all' &&
                                    hiddenWarnings.hideWarnings !== true &&
                                    !hiddenWarnings.hideWarnings.includes(w2.name)))
                                .map((w3) => w3.name);
                            if (val) {
                                // add this 'w' to list of enabled warnings
                                if (!enabledList.includes(w.name)) {
                                    enabledList.push(w.name);
                                }
                            }
                            else {
                                // remove this 'w' from the list of enabled warnings
                                if (enabledList.includes(w.name)) {
                                    enabledList = enabledList.filter((w2) => w2 !== w.name);
                                }
                            }
                            if (enabledList.length === 0) {
                                setCalendarWarnings('all');
                            }
                            else {
                                if (enabledList.length === shiftWarningTypesSorted.length) {
                                    setCalendarWarnings(undefined);
                                }
                                else {
                                    setCalendarWarnings(shiftWarningTypesSorted
                                        .filter((w2) => !enabledList.includes(w2.name))
                                        .map((w3) => w3.name));
                                }
                            }
                        };
                        // get warning count for this type
                        let wCount = null;
                        if (typeof countWarningsByType?.[w.name] !== typeof null &&
                            typeof countWarningsByType?.[w.name] !== typeof undefined)
                            wCount = countWarningsByType?.[w.name];
                        if (typeof wCount === typeof null) {
                            const key = Object.keys(countWarningsByType ?? {}).find((k) => k.includes(w.name + '_')); // sometimes, we need type like 'shiftDuration' to also match warnings like 'shiftDuration_long'. they appear, but are not in plugins.options
                            if (key)
                                wCount = countWarningsByType?.[key];
                        }
                        let noticesDivider = null;
                        if (!alreadyDisplayingNotices && w.level === 'notice') {
                            alreadyDisplayingNotices = true;
                            noticesDivider = (react_1.default.createElement("tr", { key: 'divider_' + wIdx.toString() },
                                react_1.default.createElement("td", null),
                                react_1.default.createElement("td", { className: 'is-desc-td', style: { overflow: 'visible' } },
                                    react_1.default.createElement("div", { style: { marginLeft: '-1rem' } },
                                        react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD }, (0, i18n_1.t)('WARNING_TYPES_NOTICES')))),
                                react_1.default.createElement("td", null)));
                        }
                        return (react_1.default.createElement(react_1.default.Fragment, { key: wIdx.toString() },
                            noticesDivider,
                            react_1.default.createElement("tr", { className: !disabled ? 'is-warn-enabled' : '' },
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement(_ui_1.Checkbox, { disabled: !laborlawPluginEnabled, checked: !disabled, onChange: handleChange })),
                                react_1.default.createElement("td", { className: 'is-desc-td', onClick: () => {
                                        handleChange(disabled);
                                    }, title: (0, maybe_unwrap_1.unwrapMaybe)((0, i18n_1.t)('WARNING_' + w.name)) }, (0, i18n_1.t)('WARNING_' + w.name)),
                                react_1.default.createElement("td", null, typeof wCount !== typeof null && (wCount ?? 0) > 0 ? (react_1.default.createElement(_ui_1.CircledNumber, { number: wCount ?? 0, color: _ui_1.CircledNumber.COLORS.DANGER })) : null))));
                    })))));
};
exports.WarningsTooltip = WarningsTooltip;
exports.default = exports.WarningsTooltip;
